import { Card, Col, Form, Input, Row, Switch } from 'antd'
import { FormInstance } from 'antd/lib'

import { IDNP_REGEX, PHONE_REGEX, requiredRules } from 'src/app-constants'
import { CountrySelect } from 'src/components'
import { useLocales } from 'src/locales'

const { Item } = Form

type Props = {
  form: FormInstance
  hasId?: boolean
  isDisabled?: boolean
}
export const CounterPartDetails = ({
  form,
  hasId,
  isDisabled = false
}: Props) => {
  const { t } = useLocales()

  const status = Form.useWatch('status', form)

  return (
    <Card>
      <Form
        layout="vertical"
        form={form}
        requiredMark={false}
        disabled={isDisabled}
      >
        <Row gutter={[24, 24]}>
          <Col xs={24} md={12} lg={8}>
            <Item
              name="idno"
              label={t('organizational_structure.idno')}
              rules={requiredRules?.concat({
                pattern: IDNP_REGEX,
                message: t('organizational_structure.idno_error')
              })}
            >
              <Input
                placeholder={t('organizational_structure.idno')}
                disabled={hasId}
              />
            </Item>
          </Col>

          <Col xs={24} md={12} lg={8}>
            <Item
              name="name"
              label={t('organizational_structure.name')}
              rules={requiredRules}
            >
              <Input
                placeholder={t('organizational_structure.name')}
                disabled={hasId}
              />
            </Item>
          </Col>

          <Col xs={24} md={12} lg={8}>
            <Item
              name="fiscalCode"
              label={t('other_institutions.fiscal_code')}
              rules={requiredRules?.concat({
                pattern: IDNP_REGEX,
                message: t('form.fiscal_code_error')
              })}
            >
              <Input
                placeholder={t('other_institutions.fiscal_code')}
                disabled={hasId}
              />
            </Item>
          </Col>

          <Col xs={24} md={12} xl={8}>
            <Item
              name={['contactInfo', 'phone']}
              label={t('organizational_structure.phone')}
              rules={requiredRules?.concat({
                pattern: PHONE_REGEX,
                message: t('organizational_structure.phone_error')
              })}
            >
              <Input placeholder={t('organizational_structure.phone')} />
            </Item>
          </Col>

          <Col xs={24} md={12} xl={8}>
            <Item
              name={['contactInfo', 'fax']}
              label={t('organizational_structure.fax')}
              rules={[
                {
                  pattern: PHONE_REGEX,
                  message: t('organizational_structure.phone_error')
                }
              ]}
            >
              <Input placeholder={t('organizational_structure.fax')} />
            </Item>
          </Col>

          <Col xs={24} md={12} xl={8}>
            <Item
              name={['contactInfo', 'email']}
              label={t('organizational_structure.email')}
              rules={requiredRules?.concat({ type: 'email' })}
            >
              <Input placeholder={t('organizational_structure.email')} />
            </Item>
          </Col>

          <Col xs={24} md={12} xl={5}>
            <Item label={t('common.country')} rules={requiredRules}>
              <CountrySelect
                defaultValue="md"
                disabled
                placeholder={t('common.country')}
              />
            </Item>
          </Col>
          <Col xs={24} md={12} xl={5}>
            <Item
              name={['address', 'region']}
              label={t('organizational_structure.region')}
              rules={requiredRules}
            >
              <Input placeholder={t('organizational_structure.region')} />
            </Item>
          </Col>
          <Col xs={24} md={12} xl={5}>
            <Item
              name={['address', 'locality']}
              label={t('organizational_structure.city')}
              rules={requiredRules}
            >
              <Input placeholder={t('organizational_structure.city')} />
            </Item>
          </Col>
          <Col xs={24} md={12} xl={5}>
            <Item
              name={['address', 'street']}
              label={t('organizational_structure.street')}
              rules={requiredRules}
            >
              <Input placeholder={t('organizational_structure.street')} />
            </Item>
          </Col>

          <Col xs={24} md={12} xl={4}>
            <Item
              name={['address', 'unitNumber']}
              label={t('other_institutions.number')}
              rules={requiredRules}
            >
              <Input placeholder={t('other_institutions.number')} />
            </Item>
          </Col>

          <Col xs={24} md={12} xl={4}>
            <Item
              name="status"
              label={`${t('counterparts.status')} (${status ? t('common.active') : t('common.inactive')})`}
              valuePropName="checked"
            >
              <Switch />
            </Item>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}
